let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("94EQU")).then(() => parcelRequire('140PV'));